module.exports = __webpack_public_path__ + "img/location.fd8ae19b.svg";